var module = angular.module('octopusApp.master');
var moment = require('moment');

module.directive('mainNavigationBar', function () {

    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        templateUrl: 'areas/master/views/main_navigation_bar.html',
        link: function (scope, element) {
        },
        controller: function ($scope, $rootScope, $uibModal, octopusAuthenticator, octopusRepository, pollLoop, octopusClient, $localStorage, octopusPermissionSet) {
            $scope.tab = 'dashboard';
            $scope.isAuthenticated = false;
            $scope.searchEnabled = true;
            $scope.hasProjects = false;
            $scope.projectMenuItems = null;
            $scope.showUpgradeNotification = false;
            $scope.showLicenseExpiringNotification = false;
            $scope.isAdmin = false;
            $scope.showNewNotificationsAlert = false;

            var root = $scope.rootDocument = octopusClient.rootDocument();

            $scope.canChangePassword = function() {
                return $rootScope.currentUser && $rootScope.currentUser.CanPasswordBeEdited && root.AnyAuthenticationProvidersSupportPasswordManagement;
            };

            var refreshProjects = function() {
                return octopusRepository.Dashboards.getDashboard().then(function(dashboardData) {
                    $scope.hasProjects = false;
                    var projectGroups = _.sortBy(dashboardData.ProjectGroups, function (p) { return p.Name.toLowerCase(); });

                    var projectsByGroup = { };
                    _.each(projectGroups, function (pg) {
                        projectsByGroup[pg.Id] = [];
                    });

                    _.each(_.sortBy(dashboardData.Projects, function (p) { return p.Name.toLowerCase(); }), function(project) {
                        projectsByGroup[project.ProjectGroupId].push(project);
                        $scope.hasProjects = true;
                    });

                    var allItems = [];
                    var order = 0;
                    _.each(projectGroups, function (pg) {
                        order++;
                        allItems.push( { Id: pg.Id, Order: order, Name: pg.Name, Slug: null });
                        _.each(projectsByGroup[pg.Id], function (project) {
                            order++;
                            allItems.push( { Id: project.Id, Order: order, Name: project.Name, Slug: project.Slug });
                        });
                    });

                    $scope.projectMenuItems = allItems;
                });
            };

            $scope.beginRefreshProjects = function() {
                refreshProjects();
            };

            $scope.showGettingStarted = function() {
               $uibModal.open({
                    backdrop: true,
                    keyboard: true,
                    templateUrl: 'areas/master/getting-started/views/getting_started_dialog.html',
                    controller: 'GettingStartedDialogController',
                    size: 'xlg'
                });
            };

            $scope.markNotificationsAsRead = function() {

                $scope.showNewNotificationsAlert = false;
                if ($scope.showUpgradeNotification) {
                    $localStorage.userReadUpgradeNotificationForVersion = $scope.maximumAvailableVersion;
                }

                if ($scope.showLicenseExpiringNotification) {
                    $localStorage.userReadLicenseRenewalNotificationOnDate = moment().toString();
                }
            }

            octopusRepository.ServerStatus.getServerStatus().then(function(status) {

                $scope.isUpgradeAvailable = status.IsUpgradeAvailable;
                $scope.isMajorMinorUpgrade = status.IsMajorMinorUpgrade;

                if (status.IsUpgradeAvailable) {
                    $scope.maximumAvailableVersion = status.MaximumAvailableVersion;
                    if (status.MaximumAvailableVersion === status.MaximumAvailableVersionCoveredByLicense) {
                        $scope.canUpgradeFreeOfCharge = true;
                    } else {
                        $scope.canUpgradeFreeOfCharge = false;
                        $scope.maximumAvailableVersionCoveredByLicense = status.MaximumAvailableVersionCoveredByLicense;
                        $scope.maintenanceExpires = status.MaintenanceExpires;
                    }

                    var hasReadUpgradeNotification = $localStorage.userReadUpgradeNotificationForVersion === $scope.maximumAvailableVersion;

                    // Check if we should show the upgrade bullhorn.
                    octopusRepository.UpgradeConfiguration.get().then(function (config) {
                        if (config.NotificationMode === 'AlwaysShow') {
                            $scope.showUpgradeNotification = true;
                            if ($scope.showUpgradeNotification && !hasReadUpgradeNotification) {
                                $scope.showNewNotificationsAlert = true;
                            }
                        } else if (config.NotificationMode === 'ShowOnlyMajorMinor' && $scope.isMajorMinorUpgrade) {
                            $scope.showUpgradeNotification = true;
                            if ($scope.showUpgradeNotification && !hasReadUpgradeNotification) {
                                $scope.showNewNotificationsAlert = true;
                            }
                        }
                    });
                }
            });

            // Retrieve license status which everyone can view
            octopusRepository.Licenses.getCurrentStatus().then(function (licenseStatus) {

                $scope.licenseRenewalUrl = 'https://g.octopushq.com/Renew';
                var isExpired = licenseStatus.MaintenanceExpiresIn < 0;
                var isExpiringSoon = licenseStatus.MaintenanceExpiresIn >= 0 && licenseStatus.MaintenanceExpiresIn < 15;
                $scope.showLicenseExpiringNotification = isExpiringSoon || isExpired;
                $scope.isLicenseExpired = isExpired;

                var hasReadLicenseExpiringNotificationRecently = $localStorage.userReadLicenseRenewalNotificationOnDate != null && moment(new Date($localStorage.userReadLicenseRenewalNotificationOnDate)).add(2, 'day').diff(moment()) > 0;
                if ($scope.showLicenseExpiringNotification && !hasReadLicenseExpiringNotificationRecently) {
                    $scope.showNewNotificationsAlert = true;
                }

                var perm = 'AdministerSystem';
                octopusPermissionSet.isAuthorized({ permission: perm }).then(function(yn) {
                    if(yn) {
                        // Retrieve license details so we can provide a 'Renew Now' link
                        octopusRepository.Licenses.getCurrent().then(function (license) {
                            $scope.isAdmin = license != null;
                            $scope.licenseRenewalUrl = 'https://g.octopushq.com/Renew?licenseKey=' + license.LicenseKey;
                        });
                    }
                });

            });

            var loop = pollLoop.create($scope, function() {
                return refreshProjects();
            }, 60000);

            loop.startImmediately();
        }
    };
});







//////////////////
// WEBPACK FOOTER
// ./app/areas/master/directives/main_navigation_bar.js
// module id = 2752310004769349
// module chunks = 1